import { getCookie } from '@/utils/cookies';

// CSRF token
const CsrfTokenCookieName = 'CSRF-TOKEN';
const getCsrfTokenCookie = (): string => getCookie<string>(CsrfTokenCookieName) || '';

// API token
const ApiTokenCookieName = 'expiring_api_token';
const getApiTokenCookie = (): string => getCookie<string>(ApiTokenCookieName) || '';

// Reused across calls since isJwtExpired runs in an axios request interceptor.
const jwtPayloadDecoder = new TextDecoder();

// Returns true when a JWT is past its `exp` claim. A token that can't be decoded or has no `exp`
// is treated as expired, so callers refresh rather than send a stale/malformed token.
const isJwtExpired = (token: string): boolean => {
  const parts = typeof token === 'string' ? token.split('.') : [];
  if (parts.length !== 3) return true;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = jwtPayloadDecoder.decode(Uint8Array.from(atob(padded), (char) => char.charCodeAt(0)));
    const { exp } = JSON.parse(json);
    return typeof exp === 'number' ? exp * 1000 < Date.now() : true;
  } catch {
    return true;
  }
};

export { getApiTokenCookie, getCsrfTokenCookie, isJwtExpired };
